import { PORTAL_SETTINGS } from '../../core/token/base-config.token';
import { BasePortalSettingsService } from '../../core/services/base-portal-settings.service';

export function portalSettingsFactory(service: BasePortalSettingsService) {
  return service.getSettingsSnapshot();
}

export const PORTAL_SETTINGS_PROVIDER = {
  provide: PORTAL_SETTINGS,
  deps: [BasePortalSettingsService],
  useFactory: portalSettingsFactory,
};
